<div id="manager-user-list" fxLayout="column" fxLayoutAlign="start stretch">
  <app-manager-user-create (userCreated)="onUserCreated($event)"></app-manager-user-create>
  <div fxLayout="row" fxLayoutAlign="space-between center" *ngFor="let managerUser of managerUsers">
    <div>
      {{managerUser.email}}
    </div>
  </div>
</div>
